export default __webpack_public_path__ + "static/media/overview_islamic.e176a411.gif";